import axios from 'axios';
import { toast } from 'sonner';

export async function subscribeToNewsletter(email, apiBase) {
  const API = `${apiBase}/newsletter/subscribe`;
  try {
    await axios.post(API, { email });
    toast.success('Newsletter subscribed successfully');
    return true;
  } catch (error) {
    const status = error.response?.status;
    const detail = error.response?.data?.detail;
    if (status === 400) {
      const message =
        typeof detail === 'string'
          ? detail
          : 'This email is already subscribed to the newsletter.';
      toast.error(message);
    } else {
      toast.error('Something went wrong. Please try again later.');
    }
    return false;
  }
}
